/**
 * Drop unreferenced empty LLM definition stubs before save/validate.
 * Users often add a definition by mistake while working on flows; deleting
 * flow steps does not remove definitions[] entries.
 */

function isEmptyLlmStub(step) {
    if (!step || step.kind !== 'llm') return false;
    const q = step.inputs?.query;
    return !String(step.unique_name || '').trim()
        && !String(step.model_type || '').trim()
        && !String(q || '').trim();
}

function collectReferencedDefinitionIds(steps, definitions, flows) {
    const refs = new Set();
    const scan = (list) => {
        for (const s of list || []) {
            if (!s) continue;
            if (s.kind === 'choose') {
                for (const c of s.choose?.cases || []) {
                    if (c.run?.kind === 'step' && c.run.ref) refs.add(c.run.ref);
                }
                const d = s.choose?.default;
                if (d?.kind === 'step' && d.ref) refs.add(d.ref);
            }
            if (s.kind === 'call' && s.call?.ref) refs.add(s.call.ref);
            if (s.kind === 'parallel' && Array.isArray(s.branches)) scan(s.branches);
        }
    };
    scan(steps);
    scan(definitions);
    for (const f of flows || []) scan(f.steps);
    return refs;
}

export function pruneUnusedEmptyDefinitions(definitions, steps, flows) {
    const list = Array.isArray(definitions) ? definitions : [];
    if (list.length === 0) return list;
    const refs = collectReferencedDefinitionIds(steps, list, flows);
    return list.filter((def) => {
        if (refs.has(def.id)) return true;
        return !isEmptyLlmStub(def);
    });
}
